import React from 'react';
function Icon(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill={props.fill || '#1D252D'} viewBox="0 -960 960 960">
      <path d="M212.31-140H327v-186.62H140v114.31q0 29.83 21.24 51.07T212.31-140M387-140h186v-186.62H387zm246 0h114.69q29.83 0 51.07-21.24T820-212.31v-114.31H633zM140-386.62h187v-186.76H140zm247 0h186v-186.76H387zm246 0h187v-186.76H633zM140-633.38h187V-820H212.31q-29.83 0-51.07 21.24T140-747.69zm247 0h186V-820H387zm246 0h187v-114.31q0-29.83-21.24-51.07T747.69-820H633z"></path>
    </svg>;
}
export default Icon;